import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../../../config";
import { motion } from "framer-motion";

import TicketList from "./TicketList";
import TicketThread from "./TicketThread";
import CreateTicketModal from "./CreateTicketModal";

const SupportCenter = () => {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const [loading, setLoading] = useState(true);

  const [showCreateModal, setShowCreateModal] =
    useState(false);

  const user =
    JSON.parse(localStorage.getItem("user"));

  const token = user?.token;

  // ====================================
  // FETCH TICKETS
  // ====================================
  const fetchTickets = async () => {
    try {
      const res = await axios.get(
`${API_BASE}/api/user/feedback/my-tickets`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const ticketData =

Array.isArray(
res.data?.tickets
)

?

res.data.tickets

:

Array.isArray(
res.data
)

?

res.data

:

[];

setTickets(
ticketData
);

if (

selectedTicket?._id

){

const updated =

ticketData.find(

t=>

t._id ===

selectedTicket._id

);

if (

updated

){

setSelectedTicket(
updated
);

}

}

// Auto select first ticket

if (

ticketData.length > 0 &&

!selectedTicket

){

setSelectedTicket(

ticketData[0]

);

}

    } catch (error) {
      console.error(
"Fetch Tickets Error:",
error
);

setTickets([]);
    } finally {
      setLoading(false);
    }
  };

  // ====================================
  // INITIAL FETCH
  // ====================================
  useEffect(() => {

if (token){

fetchTickets();

}

}, [token]);

  // ====================================
  // POLLING
  // ====================================
  useEffect(() => {
    const interval = setInterval(() => {
      fetchTickets();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full h-[calc(100vh-80px)] p-4">
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        className="
          w-full
          h-full
          bg-white/10
          backdrop-blur-xl
          border border-white/10
          rounded-3xl
          overflow-hidden
          shadow-2xl
          flex
        "
      >
        {/* LEFT SIDEBAR */}
        <div
          className="
            w-[350px]
            border-r
            border-white/10
            flex
            flex-col
          "
        >
          {/* HEADER */}
          <div
            className="
              p-4
              border-b
              border-white/10
              flex
              items-center
              justify-between
            "
          >
            <div>
              <h2 className="text-xl font-bold text-white">
                Support Center
              </h2>

              <p className="text-sm text-gray-400">
                Talk directly with admins
              </p>
            </div>

            <button
              onClick={() =>
                setShowCreateModal(true)
              }
              className="
                px-4
                py-2
                rounded-xl
                bg-gradient-to-r
                from-indigo-500
                to-purple-500
                text-white
                font-medium
                hover:scale-105
                transition
              "
            >
              New
            </button>
          </div>

          {/* TICKET LIST */}
          <div className="flex-1 overflow-y-auto">
            <TicketList
              tickets={tickets}
              loading={loading}
              selectedTicket={selectedTicket}
              setSelectedTicket={setSelectedTicket}
            />
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="flex-1">
          <TicketThread
            selectedTicket={selectedTicket}
            refreshTickets={fetchTickets}
          />
        </div>
      </motion.div>

      {/* CREATE MODAL */}
      {showCreateModal && (
        <CreateTicketModal
          onClose={() =>
            setShowCreateModal(false)
          }
          refreshTickets={fetchTickets}
        />
      )}
    </div>
  );
};

export default SupportCenter;